import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * Dialog — generic reusable modal for Mission Control.
 *
 * Props:
 *   show           — boolean
 *   title          — string
 *   onHide         — () => void  (called on Cancel or backdrop click)
 *   onSubmit       — () => void  (called on primary button click)
 *   submitLabel    — string (default: 'OK')
 *   submitDisabled — boolean
 *   children       — modal body content
 */
function Dialog({ show, title, onHide, onSubmit, submitLabel = 'OK', submitDisabled, children }) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !submitDisabled) onSubmit && onSubmit();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body onKeyDown={handleKeyDown}>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>Cancel</Button>
        <Button variant="success" disabled={submitDisabled} onClick={onSubmit}>
          {submitLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default Dialog;
